module.exports = {
    "id": null,
    "name": ""
};